import { Tag } from 'sonata-react-components';

type Props = {
  title: string;
  text: string;
  /** Optional tag next to the title, e.g. "Estimated". */
  tag?: string;
};

/** Body of a KPI info tooltip: bold title (and tag) over its explanation. */
export default function KpiTooltipContent({ title, text, tag }: Readonly<Props>) {
  return (
    <div className="metricDetailCards__tooltip">
      <div className="metricDetailCards__tooltipHeader">
        <strong>{title}</strong>
        {tag && (
          <Tag id={`kpiTooltip-${title}`} status="warning" tiny>
            {tag}
          </Tag>
        )}
      </div>
      <span>{text}</span>
    </div>
  );
}
